import { combineReducers } from 'redux';

import genericErrorReducer from 'modules/global/reducers/generic.error';
import genericLoadingReducer from 'modules/global/reducers/generic.loading';
import genericPageReducer from 'modules/global/reducers/generic.page';
import * as types from 'modules/statistics/actionTypes';

import data from './data';
import filters from './filters';

export default combineReducers({
  filters,
  data,
  page: genericPageReducer(types.FETCH_EXTRA_DETAILS_STATS),
  apiError: genericErrorReducer(types.FETCH_EXTRA_DETAILS_STATS),
  loading: genericLoadingReducer(types.FETCH_EXTRA_DETAILS_STATS),
});
